"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRACKER_CONFIG = exports.SNOWPLOW_TRACKER_NAME = void 0;
/**
 * This is the name of the tracker that will appear in the cookies.
 * Default is 'sp', however that could be confused with Service Provider so
 * opted to rename to 'snpl'.
 */
exports.SNOWPLOW_TRACKER_NAME = 'snpl';
/**
 * Configuration to be used when initializing the Snowplow Tracker.
 */
exports.DEFAULT_TRACKER_CONFIG = {
    platform: 'web',
    cookieName: exports.SNOWPLOW_TRACKER_NAME,
    cookieSameSite: 'Lax',
    respectDoNotTrack: false,
    discoverRootDomain: true,
    contexts: {
        webPage: true,
        session: true,
        browser: true,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYWNrZXIvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBOzs7O0dBSUc7QUFDVSxRQUFBLHFCQUFxQixHQUFHLE1BQU0sQ0FBQztBQUU1Qzs7R0FFRztBQUNVLFFBQUEsc0JBQXNCLEdBQXlCO0lBQ3hELFFBQVEsRUFBRSxLQUFLO0lBQ2YsVUFBVSxFQUFFLDZCQUFxQjtJQUNqQyxjQUFjLEVBQUUsS0FBSztJQUNyQixpQkFBaUIsRUFBRSxLQUFLO0lBQ3hCLGtCQUFrQixFQUFFLElBQUk7SUFDeEIsUUFBUSxFQUFFO1FBQ04sT0FBTyxFQUFFLElBQUk7UUFDYixPQUFPLEVBQUUsSUFBSTtRQUNiLE9BQU8sRUFBRSxJQUFJO0tBQ2hCO0NBQ0osQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../src/tracker/constants.ts